import { IDBPDatabase, openDB } from 'idb';

const DB_NAME = 'app-db';
const DB_VERSION = 1;

export const INDEXED_DB_STORES = {
  TASK_FORM_DATA: 'task-form-data',
  USER_CACHE: 'user-cache',
} as const;

type StoreName = (typeof INDEXED_DB_STORES)[keyof typeof INDEXED_DB_STORES];

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDB() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        Object.values(INDEXED_DB_STORES).forEach(storeName => {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName);
          }
        });
      },
    });
  }

  return dbPromise;
}

/* ================= PUBLIC API ================= */

export async function dbGet<T>(store: StoreName, key: string): Promise<T | undefined> {
  const db = await getDB();
  return db.get(store, key);
}

export async function dbSet(store: StoreName, key: string, value: unknown) {
  const db = await getDB();
  return db.put(store, value, key);
}

export async function dbDelete(store: StoreName, key: string) {
  const db = await getDB();
  return db.delete(store, key);
}

export async function dbClear(store: StoreName) {
  const db = await getDB();
  return db.clear(store);
}

export async function dbGetAll<T>(store: StoreName): Promise<T[]> {
  const db = await getDB();
  return db.getAll(store);
}
